import React from "react"

export default function Blog022() {
  return (
    <section>
    <article>
    <h2>23. 10-28-2022</h2>
          <h3>REST</h3>
          <p>
          <strong>Hi!</strong>
          <br />
          I took a few days experimenting with LESS. With an understanding of implementation, I am moving
           on to the next step of my curriculum. My updated curriculum is as follows. <br />
           </p>
           <h5>Curriculum</h5>
           <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>JAVASCRIPT</li>
            <li>GITHUB</li>
            <li>Bootstrap</li>
            <li>REACT.JS</li>
            <li>GIT + NETLIFY</li>
            <li>LESS</li>
            <li>REST</li>
            <li>REACT NATIVE</li>
            <li>PYTHON</li>
            <li>TYPESCRIPT</li>
            <li>LINUX</li>
            <li>SCSS</li>
            <li>XML</li>
            <li>JAVA</li>
            <li>SQL</li>
           </ul>

          <p>
            I am currently moving forward with REST. This is to compliment React, and in the near future, 
            Python. I have the long term goal of being a Full-Stack Developer. I am starting with Front-End 
            Development. I have chose this based on my past experience as an Animator. I understand and 
            enjoy making things look awesome. I found the most enjoyable part of animation was learning 
            new software and creating unique content. It feels like programming has that same value, but 
            without limitation! An animated video must be played on a video player; Not only that, the video 
            dimensions are limited to its user interface. Front-End Programming is like graphic design that you 
            can add buttons to! Alright, that's a bit of an over simplification, but I think it gets the point across. 
            
            <br />
            <br />
            The first step, REST, will be a huge help while communicating with back-end development. I am 
            excited for this step! As far as I understand it, this will bridge the gap between ReactJS/JavaScript 
            and other languages using a universal communication method. 
            <br />
            <br />
            I am going to continue to work on React projects, and update those already existing; like this website. 
            I am going to record the 'month four' monthly vlog video update soon. I also have a few online meet-ups to attend, along 
            with a 'Coffee and Code' Meet-up here in Spokane. I would like to set up a meet-up for coders as well, 
            when I find the time and place I will update it here and make a designated web page.
            <br />
            <br />
            With all of that, I will sign off and get back to work. Thank you for reading!

          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
